import { ConnectedRouter } from "connected-react-router";
import * as qs from "query-string";
import * as React from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";
import { Dispatch } from "redux";
import { IntegrationEnv } from "humboldt";
import { CallbackRoute, RequiresAuth } from "./auth/components/containers";
import ProfileSelector from "./components/connected/ProfileSelector";
import Welcome from "./components/connected/Welcome";
import * as actions from "./root/actions";
import * as actionTypes from "./root/actionTypes";
import { Integration } from "./root/Integration";
import { history, store } from "./stores/index";
import "./styles/index.css";

const WelcomePage = () => <Welcome />;

const onProfileSelected = (dispatch: Dispatch<actionTypes.AppAction>, integration: Integration, env: IntegrationEnv) => (
    profileId: string,
) => {
    actions.selectProfile(
        dispatch,
        integration,
        env,
        profileId,
    );
};

const SelectProfilePage = (props: any) => {
    const { location } = props;
    const keys = qs.parse(location.search);
    const appIdentifier = keys.app as string;
    let envStr = keys.env as string;
    const integration: Integration | undefined = Object.values(Integration).find((x: Integration) => x === appIdentifier);
    if (!integration) { throw new Error("Unable to map app identifier to a valid integration"); }

    if (!envStr) { envStr = IntegrationEnv.PROD.toString(); }
    const env = Object.values(IntegrationEnv)
        .find((x: IntegrationEnv) => x.toLowerCase() === envStr.toLowerCase());
    if (!env) { throw new Error("Unable to map app identifier to a valid integration"); }

    return (
        <ProfileSelector
            action={onProfileSelected(store.dispatch, integration, env)}
        />
    );
};

class App extends React.Component {
    render() {
        return (
            <div>
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <Switch>
                            <Route exact path="/" render={WelcomePage} />
                            <RequiresAuth
                                path="/choose_profile"
                                render={SelectProfilePage}
                            />
                            <CallbackRoute path="/callback" />
                        </Switch>
                    </ConnectedRouter>
                </Provider>
            </div>
        );
    }
}

export default App;
